import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'
import type { CreateProductType } from '@src/type/product/form'

export interface CreateVendorProductResponse extends Response {
	data: Record<string, unknown>
}

export const createVendorProduct = async (
	newProduct: CreateProductType,
): Promise<CreateVendorProductResponse> => {
	const response = await client.post<CreateVendorProductResponse>(`/vendors/products`, newProduct)

	return response.data
}
